import { Device, ProductModelService, System } from "../models";
import { ConnextDevice, ConnextData } from "../telemetry";

export const ADVANCED_PLANTS_LIMIT = 3;

const cleanList = (list: ConnextDevice[] | undefined) => list?.
  filter((connextDevice) => (new ProductModelService(connextDevice.sn).type?.name));

const currentDevicesListHasOneDeviceMoreThanDatabase = (system: System, connextData: Partial<ConnextData>) =>
  system.devices.length === ((cleanList(connextData.devices)?.length || 0) + 1);

const currentDevicesListContainAllDatabaseDevices = (system: System, connextData: Partial<ConnextData>) => {
  const databaseDeviceIds = cleanList(connextData.devices)?.map((dev) => dev.sn.toUpperCase()) ?? [];
  const devicesIncluded = system.devices.filter((device) => databaseDeviceIds.includes(device.id.toUpperCase())).length;
  return (devicesIncluded + 1) === system.devices.length;
};

export const getUpdatedList = async (devices: Device[], connextDevices: ConnextDevice[]) => {
  const connext = devices.find((device) => device.type === 'connext');
  if (!connext) {
    throw new Error ('Missing connext');
  }
  const updatedDeviceList = [connext];
  const mapToDevice = (connextDevice: ConnextDevice) => {
    const product = new ProductModelService(connextDevice.sn);
    const type = product.type?.name;
    if (type) {
      updatedDeviceList.push({
        id: connextDevice.sn,
        name: connextDevice.sn,
        type,
      });
    }
  };
  connextDevices.forEach(mapToDevice);
  return updatedDeviceList;
};

/**
 * @abstract return updatedList only if there are changes (removed or added devices)
 */
export const getUpdatedSystems = async (system: System, connextData: Partial<ConnextData>, systems: System[]) => {
  if (
      currentDevicesListContainAllDatabaseDevices(system, connextData) &&
      currentDevicesListHasOneDeviceMoreThanDatabase(system, connextData) &&
      system.connextSn
    ) {
    return;
  }

  const updatedDeviceList = await getUpdatedList(system.devices, connextData.devices || []);
  if (updatedDeviceList) {
    return systems?.map((currentSystem) => {
      if (currentSystem.uid === system.uid) {
        return {
          ...currentSystem,
          devices: updatedDeviceList,
          connextSn: connextData.info?.sn.sn || '',
        };
      }
      return currentSystem;
    });
  }
  return;
};
